export class FinesseMakeCall {
 private user:any;
 private log:any;
 private prefix:any;
    constructor (
        user:any,
        log:any,
        prefix:any
    ) {
        this.user=user;
        this.log=log;
        this.prefix=prefix;
    }

    public dial(phone:string){
        let phonetodial=phone;
        if(this.prefix?.length>0){
            phonetodial=this.prefix+phonetodial;
        }
        this.log.debug("[one-view]" ,"[FinesseMakeCall] Initiated click to call to ",phonetodial);
        if(this.user){
        this.user.makeCall(phonetodial,{
            success: (rsp: any) => {
                this.log.debug("[one-view]" ,"[FinesseMakeCall] make a call success");
            },
            error: (errorrsp: any) => {
                this.log.error("[one-view]" ,"[FinesseMakeCall] erorr in make a call",errorrsp);
            }});
    }
}
}